import axios from 'axios';
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const API_PATH = `${process.env.REACT_APP_ENV === 'local' ? '' : '/tsp'}/manage/dashboard`;
const API_PATH_V2 = `${process.env.REACT_APP_ENV === 'local' ? '' : '/v2'}/manage/dashboard`;

export const functionHandle = createAsyncThunk('function', async () => {
	const response = await axios.get(`${API_PATH}/permissions`);
	return response;
	// const response = await axios.get(`${API_PATH_V2}/permissions`);
	// return response.data;
});

export const functionSlice = createSlice({
    name: 'function',
    initialState: {
		functions: null
    },
	reducers: {
		resetState: (state, props) => {
			state.functions = null;
		}
	},
    extraReducers: builder => {
		builder.addCase(functionHandle.fulfilled, (state, { payload }) => {
			state.functions = payload;
		})
    }
})

export const { resetState } = functionSlice.actions;
export default functionSlice.reducer;
